import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SimplePaginationModel } from 'src/app/models/pagination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
// import { PriceListService } from 'src/app/services/priceList.service';
import { PlaceService } from 'src/app/services/place.service';
// import { AssociationPlacePriceListService } from 'src/app/services/association-place-priceList.service';
import { ProductPriceListResponse } from 'src/app/models/price-list.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { AssociationPlaceDestinationService } from 'src/app/services/association-place-destination.service';
import { AssociationPlacePriceListService } from 'src/app/services/association-place-location.service';


@Component({
  selector: 'app-association-price-list-place',
  templateUrl: './association-price-list-place.component.html',
  styleUrls: ['./association-price-list-place.component.scss']
})
export class AssociationPriceListPlaceComponent {
  loading = false;

  allPlaces: any[] = [];
  allPriceLists: ProductPriceListResponse [] = [];

  places: any[] = [];
  priceListLists: ProductPriceListResponse [] = [];

  filterPlaces = '';
  filterPriceLists = '';

  selectedPlaceId: number | null = null;
  selectedPlace: any = null;

  initialRelatedPriceListIdsBefore: number[] = [];
  currentRelatedPriceListIds: number[] = [];
  currentRelatedPriceLists: any[] = [];

  paginationPlaces = new SimplePaginationModel(0, 5, 0, 0, 0);
  paginationPriceLists = new SimplePaginationModel(0, 5, 0, 0, 0);

  @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;
  @HostListener('window:resize') onResize() { this.drawMultipleLinks(); }

  private timeoutPlaces: any = null;
  private timeoutPriceLists: any = null;

  constructor(
    private toastService: ToastrService,
    private placeService: PlaceService,
    // private priceListService: PriceListService,
    private priceListService: InventoryService, 
    private associationService: AssociationPlacePriceListService
  ) { }

  ngOnInit(): void {
    this.loadStartData();
  }


  loadStartData() {
    this.loadPlaces();
    this.loadPriceLists();
  }

  loadPlaces() {
    this.placeService.getPlaces().subscribe({
      next: (resp: ResponseObject) => {
        this.allPlaces = resp.data || [];
        this.refreshPlacesPagination();
      },
      error: () => this.toastService.error('Error al obtener ubicaciones')
    });
  }

  loadPriceLists() {
    this.priceListService.getProductPricesList().subscribe({
      next: (response: ResponseObject) => {
        this.allPriceLists = response.data || [];
        this.refreshPriceListsPagination();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("No se pueden obtener las listas de precios.", "Error")
      }
    });
  }

  selectPlace(placeId: number) {
    if (this.selectedPlaceId === placeId) return;

    this.selectedPlaceId = placeId;
    this.selectedPlace = this.allPlaces.find(p => p.id === placeId);

    this.currentRelatedPriceListIds = [];
    this.currentRelatedPriceLists = [];

    this.associationService.getAssociationsByPlace(placeId).subscribe({
      next: (resp: ResponseObject) => {
        const associations = resp.data || [];

        const relatedIds: number[] = associations.map((a: any) => a.priceListId);

        this.initialRelatedPriceListIdsBefore = [...relatedIds];
        this.currentRelatedPriceListIds = [...relatedIds];

        this.currentRelatedPriceLists = this.allPriceLists.filter(d =>
          relatedIds.includes(d.id)
        );

        this.refreshPriceListsPagination();
        this.drawMultipleLinks();
      },
      error: (error) => {
        console.error(error);
        this.toastService.error('Error al obtener asociaciones de la ubicación');
      }
    });
  }

  togglePriceList(d: any) {
    if (!this.selectedPlaceId) {
      this.toastService.warning('Selecciona primero una ubicación.');
      return;
    }

    const idx = this.currentRelatedPriceListIds.indexOf(d.id);
    if (idx === -1) {
      this.currentRelatedPriceListIds.push(d.id);
    } else {
      this.currentRelatedPriceListIds.splice(idx, 1);
    }

    this.currentRelatedPriceLists = this.allPriceLists.filter(dest =>
      this.currentRelatedPriceListIds.includes(dest.id)
    );

    this.refreshPriceListsPagination();
    this.drawMultipleLinks();
  }

  getDisabledSave(): boolean {
    const initialSet = new Set(this.initialRelatedPriceListIdsBefore);
    const currentSet = new Set(this.currentRelatedPriceListIds);

    const toAdd = this.currentRelatedPriceListIds.some(id => !initialSet.has(id));
    const toRemove = this.initialRelatedPriceListIdsBefore.some(id => !currentSet.has(id));

    return !(toAdd || toRemove) || !this.selectedPlaceId || this.loading;
  }


  saveAssociation() {
    if (!this.selectedPlaceId) return;

    const placeId = this.selectedPlaceId;

    const initialSet = new Set(this.initialRelatedPriceListIdsBefore);
    const currentSet = new Set(this.currentRelatedPriceListIds);

    const toAdd = this.currentRelatedPriceListIds.filter(id => !initialSet.has(id));
    const toRemove = this.initialRelatedPriceListIdsBefore.filter(id => !currentSet.has(id));

    if (toAdd.length === 0 && toRemove.length === 0) {
      this.toastService.info('No hay cambios por guardar.');
      return;
    }

    this.loading = true;

    const ops = [
      ...toAdd.map(did => this.associationService.createAssociation(placeId, did)),
      ...toRemove.map(did => this.associationService.deleteAssociation(placeId, did))
    ];

    forkJoin(ops).subscribe({
      next: () => {
        this.toastService.success('Asociaciones actualizadas correctamente', 'Éxito');
        this.loading = false;
        this.selectPlace(placeId);
      },
      error: (e: HttpErrorResponse) => {
        // console.log(e.error.message);
        
        this.toastService.error(e?.error.data.description || 'Error al actualizar asociaciones', 'Error');
        this.loading = false;
      }
    });
  }


  debouncedFilterPlaces() {
    clearTimeout(this.timeoutPlaces);
    this.timeoutPlaces = setTimeout(() => {
      this.paginationPlaces.page = 0;
      this.selectedPlaceId = null;
      this.refreshPlacesPagination();
      this.drawMultipleLinks();
    }, 250);
  }

  refreshPlacesPagination() {
    const q = (this.filterPlaces || '').toLowerCase();
    const filtered = this.allPlaces.filter(p =>
      (p.name || '').toLowerCase().includes(q)
    );

    this.paginationPlaces.total = filtered.length;
    this.paginationPlaces.start = this.paginationPlaces.page * this.paginationPlaces.size;
    const end = this.paginationPlaces.start + this.paginationPlaces.size;
    this.paginationPlaces.end = Math.min(end, filtered.length);

    this.places = filtered.slice(this.paginationPlaces.start, this.paginationPlaces.end);
    this.drawMultipleLinks();
  }

  debouncedFilterPriceLists() {
    clearTimeout(this.timeoutPriceLists);
    this.timeoutPriceLists = setTimeout(() => {
      this.paginationPriceLists.page = 0;
      this.refreshPriceListsPagination();
    }, 250);
  }

  refreshPriceListsPagination() {
    const q = (this.filterPriceLists || '').toLowerCase();
    const matches = (d: any) =>
      (d.name || '').toLowerCase().includes(q);

    const associatedSet = new Set(this.currentRelatedPriceListIds);
    const pinned = this.allPriceLists.filter(d => associatedSet.has(d.id));
    const rest = this.allPriceLists.filter(d => !associatedSet.has(d.id) && matches(d));

    const final = [...pinned, ...rest];

    this.paginationPriceLists.total = final.length;
    this.paginationPriceLists.start = this.paginationPriceLists.page * this.paginationPriceLists.size;
    const end = this.paginationPriceLists.start + this.paginationPriceLists.size;
    this.paginationPriceLists.end = Math.min(end, final.length);

    this.priceListLists = final.slice(this.paginationPriceLists.start, this.paginationPriceLists.end);

    this.drawMultipleLinks();
  }

  drawMultipleLinks() {
    const svg = this.svgContainer?.nativeElement as SVGElement;
    if (!svg) return;

    svg.innerHTML = '';

    if (!this.selectedPlaceId || this.currentRelatedPriceListIds.length === 0) return;

    setTimeout(() => {
      const parentRect = (svg.parentElement as HTMLElement).getBoundingClientRect();
      const selectedRow = document.querySelector('#table-places tr.selected') as HTMLElement;
      if (!selectedRow) return;

      const selectedRect = selectedRow.getBoundingClientRect();
      const x1 = selectedRect.right - parentRect.left - 12;
      const y1 = selectedRect.top + selectedRect.height / 2 - parentRect.top;

      for (const did of this.currentRelatedPriceListIds) {
        const relatedRow = document.querySelector(`#table-priceLists tr[data-id="${did}"]`) as HTMLElement;
        if (!relatedRow) continue;

        const rect = relatedRow.getBoundingClientRect();
        const x2 = rect.left - parentRect.left - 12;
        const y2 = rect.top + rect.height / 2 - parentRect.top;
        const xMiddle = x1 + ((x2 - x1) / 2);

        this.drawLine(svg, x1, xMiddle, y1, y1);
        this.drawLine(svg, xMiddle, x2, y2, y2);
        this.drawLine(svg, xMiddle, xMiddle, y1, y2);
      }
    }, 50);
  }

  private drawLine(svg: SVGElement, x1: number, x2: number, y1: number, y2: number) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', String(x1));
    line.setAttribute('y1', String(y1));
    line.setAttribute('x2', String(x2));
    line.setAttribute('y2', String(y2));
    line.setAttribute('stroke', '#14532d');
    line.setAttribute('stroke-width', '2');
    svg.appendChild(line);
  }
}
